import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"
import { LineChart } from "@mui/x-charts"
import moment from "moment"

function TechniciansWorkload() {
  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState([])
  const [historical, setHistorical] = useState([])
  const [predicted, setPredicted] = useState([])
  const [filters, setFilters] = useState({ technician_id: "" })
  const [technicians, setTechnicians] = useState([])

  useEffect(() => {
    loadData()
  }, [filters])

  function loadData() {
    setLoading(true)

    Api.get(
      `analytics/technicians-workload?technician_id=${filters.technician_id}`,
    )
      .then((res) => {
        setLabels(
          res.data.chart_data.labels?.map((date) => {
            return moment(date, "DD.MM").isSame(moment(), "day") ? "Днес" : date
          }) || [],
        )
        setHistorical(res.data.chart_data.historical || [])
        setPredicted(res.data.chart_data.predicted || [])
        setTechnicians(res.data.technicians || [])

        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  const historicalSeries = labels.map((_, i) =>
    i < historical.length ? (historical[i] ?? null) : null,
  )

  const boundaryIndex = historical.length - 1
  const predictedSeries = labels.map((_, i) => {
    if (i === boundaryIndex) return historical[boundaryIndex] ?? null
    if (i > boundaryIndex) return predicted[i - historical.length] ?? null
    return null
  })

  function hasAnyData() {
    return labels.length > 0
  }

  function handleFilterChange(e) {
    const { name, value } = e.target

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <div className="repair-requests-chart">
      <div className="head">
        <h3>{trans("analytics.technicianLoad")}</h3>
        <div className="right">
          {loading ? (
            <Skeleton height={40} width={140} count={1} />
          ) : (
            <select
              value={filters.technician_id || ""}
              name="technician_id"
              onChange={handleFilterChange}
            >
              {technicians.map((technician) => (
                <option key={technician.id} value={technician.id}>
                  {technician.full_name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !hasAnyData() ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <LineChart
          xAxis={[{ scaleType: "point", data: labels }]}
          series={[
            {
              id: "tw-hist",
              curve: "linear",
              label: "Исторически данни",
              area: true,
              data: historicalSeries,
              color: "#4A3AFF",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
            {
              id: "tw-pred",
              curve: "linear",
              label: "Прогноза",
              data: predictedSeries,
              color: "#4A3AFF",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
          ]}
          height={400}
          sx={{
            "& .MuiLineElement-series-tw-pred": { strokeDasharray: "6 3" },
            "& .MuiAreaElement-series-tw-hist": {
              fill: "url(#tw-hist-gradient)",
            },
            "& .MuiLineElement-root": { strokeWidth: 1 },
          }}
          slotProps={{
            legend: { hidden: true },
          }}
        >
          <defs>
            <linearGradient id="tw-hist-gradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4A3AFF" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#4A3AFF" stopOpacity={0.02} />
            </linearGradient>
          </defs>
        </LineChart>
      )}
    </div>
  )
}

export default TechniciansWorkload
